export default __webpack_public_path__ + "static/media/copy_ico.5d1fbf24.svg";